import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getAuthUserId } from "../../../utils/auth.util";
import moment from "moment";
import { Slide } from "@mui/material";
import { formatMessageTime } from "utils/messages.util";

const MessageItem = ({ msg }: { msg: any }) => {
  const authId = getAuthUserId();
  const isLoggedInUserMessage = msg.user._id === authId;
  return (
    <Box
      display="flex"
      justifyContent={
        `${isLoggedInUserMessage ? "flex-end" : "flex-start"}` as string
      }
      px="3%"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        alignItems={isLoggedInUserMessage ? "end" : "start"}
        mt={2}
        mb={1}
        sx={{ maxWidth: { md: "60%", sm: "100%", lg: "60%" } }}
      >
        <Box
          // borderRadius="0.8rem"
          // padding={"0.4rem 1rem"}
          borderRadius={
            msg.user._id !== authId ? "10px 10px 10px 0" : "10px 10px 0px 10px"
          }
          padding="15px"
          style={{
            ...(msg.user._id !== authId
              ? {
                  background: "#E9ECE1",
                }
              : {
                  background: "#6E8C20",
                }),
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "15px",
              lineHeight: "22px",
            }}
            color={msg.user._id !== authId ? "#323232" : "#FFF"}
            // textAlign={isLoggedInUserMessage ? "right" : "justify"}
          >
            {msg.text}
          </Typography>
        </Box>
        <Typography
          sx={{
            mt: "8px",
            color: "#A2A2A2",
            fontSize: "13px",
            fontWeight: 400,
            lineHeight: "22px",
          }}
          textAlign={isLoggedInUserMessage ? "right" : "justify"}
        >
          {formatMessageTime(msg.createdAt * 1000)}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageItem;
